<div class="spinner-bg" *ngIf="isLoading">
  <div class="spinner-container">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>
